<template>
    <div
        style="
background: #F5F5F5;"
    >
        <top></top>
        <div class="container">
            <breadcrumb :url="url"></breadcrumb>
         <div v-html="xml">

         </div>

        </div>



        <bottom></bottom>
    </div>
</template>
<script>
import top from "../../components/top.vue";
import breadcrumb from "../../components/breadcrumb.vue";
import bottom from "../../components/bottom.vue";
import { informationInfo } from "@/api/index.js";
export default {
    data() {
        return {
            url: [{ name: "咨询详情", url: "/newInfoDetail" }],
            xml:''

        };
    },
    created() {
    
    this.getInformation()
    },
    methods: {
    getInformation(){

    informationInfo({id:this.$route.query.content}).then(res=>{
    console.log(res);
    this.xml =  res.data.info.content
    })
    }
    },
    components: {
        top,
        breadcrumb,
        bottom
    },
     computed: {
        orderData: function() {
            return this.geRecrutLists.slice(
                (this.currentPage - 1) * this.pageSize,
                this.currentPage * this.pageSize
            );
        }
    }
};
</script>
<style lang="less" scoped>
.container{
    // height: 500px;
}

</style>



// WEBPACK FOOTER //
// src/views/index/newInfoDetail.vue